<nav class="munily-wizard-stepper" aria-label="Wizard progress">
  <ng-container *ngFor="let step of steps; let i = index; trackBy: trackStep">
    <button
      type="button"
      class="munily-wizard-stepper__item"
      [class.is-active]="isActive(step)"
      [class.is-done]="isDone(step)"
      [disabled]="isStepDisabled(step)"
      [class.is-locked]="isStepDisabled(step)"
      (click)="onStepClick(step)"
    >
      <span class="munily-wizard-stepper__num">
        <mat-icon
          *ngIf="isDone(step); else stepNumber"
          class="material-symbols-rounded mi s16"
          aria-hidden="true"
        >check</mat-icon>
        <ng-template #stepNumber>{{ step.displayIndex ?? step.id }}</ng-template>
      </span>
      <span class="munily-wizard-stepper__label">{{ step.label }}</span>
    </button>
    <span
      *ngIf="i < steps.length - 1"
      class="munily-wizard-stepper__sep"
      aria-hidden="true"
    ></span>
  </ng-container>
</nav>
